module.exports = __webpack_public_path__ + "img/Weapon_34.1312bd44.png";